import { Expose } from 'class-transformer';

export class CredentialsModel {
    @Expose({ name: 'access_token' })
    public accessToken: string;

    @Expose({ name: 'token_type' })
    public tokenType: string;

    @Expose({ name: 'refresh_token' })
    public refreshToken: string;

    @Expose({ name: 'expires_in' })
    public expiresIn: number;

    public scope: string;

    public sofologist: boolean = false;

    public userId: string | null = null;
}